import { useId } from 'react';
import { useTranslation } from 'react-i18next';

interface FieldTypeFilterProps {
  value: string | null;
  onChange: (value: string | null) => void;
}

/** Paginafilter veldtype van de productenlijst (spec-tabelfilters story 9). */
export function FieldTypeFilter({ value, onChange }: FieldTypeFilterProps) {
  const { t } = useTranslation();
  const id = useId();

  return (
    <div data-testid="field-type-filter" className="flex items-center gap-2">
      <label
        htmlFor={id}
        className="text-xs font-medium"
        style={{ color: 'var(--foreground-muted)' }}
      >
        {t('products.filterByFieldType')}
      </label>
      <select
        id={id}
        data-testid="field-type-select"
        value={value ?? ''}
        onChange={(e) => onChange(e.target.value || null)}
        className="rounded-lg py-[5px] px-2.5 pr-7 text-xs"
        style={{
          border: '1px solid var(--border)',
          backgroundColor: 'var(--background)',
          color: 'var(--foreground)',
          appearance: 'none',
        }}
      >
        <option value="">{t('products.allFieldTypes')}</option>
        <option value="required">{t('products.requiredFields')}</option>
        <option value="optional">{t('products.optionalFields')}</option>
      </select>
    </div>
  );
}
